import {
  createPaginationParam,
  createQueryFilters,
  DataContextPaginationCursor,
  DataContextState,
} from 'context/DataContext';
import LoanDatatableFragments from 'features/drilldown/LoanDatatable/fragments';
import { StratificationsFragments } from 'features/drilldown/Stratifications';
import { PoolSummaryFragments } from 'features/loanPool/PoolSummary';

import { gql } from '@apollo/client';

import { AssetClass, FilterableField, FilterOperator } from '__generated__/globalTypes';

import { GetDrilldownVariables } from './__generated__/GetDrilldown';

const GET_DRILLDOWN_QUERY = gql`
  query GetDrilldown($sort: Sort!, $pagination: Pagination!, $filters: [Filter!]) {
    user {
      id
      company {
        id
        loans(sort: $sort, pagination: $pagination, filters: $filters) {
          id
          ...LoanDatatableLoan
        }
        performanceData: performance_summary(filters: $filters) {
          ...LoanDatatablePerformanceSummary
          ...PoolSummaryPerformanceSummary
          ...StratificationsPerformanceSummary
        }
        totalPerformanceData: performance_summary(filters: []) {
          ...PoolSummaryPerformanceSummary
        }
      }
    }
  }
  ${LoanDatatableFragments.loan}
  ${LoanDatatableFragments.performanceSummary}
  ${PoolSummaryFragments.performanceSummary}
  ${StratificationsFragments.performanceSummary}
`;

const toGetDrilldownVariables = (
  state: DataContextState,
  paginationCursors: DataContextPaginationCursor[],
  assetClass?: AssetClass,
): GetDrilldownVariables => {
  const queryFilters = createQueryFilters(state.assetClass, state.filters);
  return {
    sort: state.sort,
    pagination: createPaginationParam(paginationCursors, state.pagination),
    filters: queryFilters,
  };
};

export { GET_DRILLDOWN_QUERY, toGetDrilldownVariables };
